import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ChevronDownIcon, HelpCircleIcon } from 'lucide-react';
import { faqs } from '../data/content';
import { Eyebrow, SectionTitle } from './ui/Section';
const collapseTransition = {
  duration: 0.22,
  ease: [0.23, 1, 0.32, 1] as const
};
export function Faq() {
  const [open, setOpen] = useState(0);
  return <section className="border-y border-line bg-white px-4 py-12 md:py-14" data-id="element-43" data-mp="2e067y48snqwi">
      <div className="mx-auto max-w-3xl" data-id="element-44" data-mp="2dy3jhonai5tw">
        <Eyebrow data-id="element-45" data-mp="2913elh26f94d">
          <span className="inline-flex items-center gap-2" data-id="element-46" data-mp="292o6eyx3wdyj">
            <HelpCircleIcon className="h-4 w-4" data-id="element-47" data-mp="242077pyq4qt8" /> Preguntas frecuentes
          </span>
        </Eyebrow>
        <SectionTitle data-id="element-48" data-mp="1z3owze4ioeah">
          Lo que más <span className="text-accent" data-id="element-49" data-mp="1z2dtlfezh8jw">nos preguntan</span>
        </SectionTitle>
        <div className="mt-8 space-y-3" data-id="element-50" data-mp="so65ke0nllx1">
          {faqs.map(([question, answer], index) => <div key={question} className={`overflow-hidden rounded-2xl border bg-white transition-colors duration-150 ease-out ${open === index ? 'border-accent/60 shadow-lg shadow-slate-200' : 'border-line'}`} data-id="element-51" data-mp="nnqr1j4my8dh" data-mpi={index}>
              <button className="flex w-full items-center justify-between gap-3 p-5 text-left text-sm font-extrabold text-ink md:text-base" onClick={() => setOpen(open === index ? -1 : index)} aria-expanded={open === index} data-id="element-52" data-mp="ueofg1sx2nco">
                {question}
                <ChevronDownIcon className={`h-5 w-5 shrink-0 text-accent transition-transform duration-200 ease-out ${open === index ? 'rotate-180' : ''}`} data-id="element-53" data-mp="bhwpj9ivd9zn" />
              </button>
              <AnimatePresence initial={false} data-id="element-54" data-mp="1rtz9h34ua50">
                {open === index && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={collapseTransition} className="border-t border-line px-5 py-4 text-sm font-semibold leading-relaxed text-slate-600" data-id="element-55" data-mp="3jy8dlh5bcm3x">
                    {answer}
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}